export default __webpack_public_path__ + "static/media/indoor-4.53025bef.png";